import { ChangeControlActionItem } from "./change-control-action-item";

export class ChangeControlActionPlan {
    ChangeControlNumber!: string;
    ActionItems!: ChangeControlActionItem[];
}